export const spacing = size => size * 8
